import { TRect } from '../types'

export default function getElementClientRect(element: HTMLElement | Window): TRect {
    if (element instanceof Window) {
        const width = window.innerWidth
        const height = window.innerHeight
        return {
            width,
            height,
            top: 0,
            left: 0,
            bottom: height,
            right: width,
            x: 0,
            y: height
        }
    }

    const { x, y, width, height, top, bottom, left, right } = element.getBoundingClientRect()
    return {
        x,
        y,
        width,
        height,
        top,
        bottom,
        left,
        right
    }
}
